import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const services = [
  {
    icon: 'ri-car-line',
    number: '01',
    title: 'Vehicle Export',
    subtitle: 'EV Cars & Automobiles',
    description:
      'Export of electric vehicles and automobiles to Ethiopia, Djibouti, Dubai, and growing African and Middle Eastern markets. End-to-end logistics from factory to destination.',
    markets: ['Ethiopia', 'Djibouti', 'Dubai'],
  },
  {
    icon: 'ri-building-4-line',
    number: '02',
    title: 'Construction Machinery',
    subtitle: 'Heavy Equipment Supply',
    description:
      'Supply of excavators, bulldozers, cranes, and full suites of heavy construction machinery for major development projects across Africa and the Middle East.',
    markets: ['Excavators', 'Cranes', 'Bulldozers'],
  },
  {
    icon: 'ri-hotel-line',
    number: '03',
    title: 'Project Procurement',
    subtitle: 'Hotels, Villas & Developments',
    description:
      'Full-scale sourcing and procurement for large development projects — from hotel FF&E to villa furnishings and construction materials for multi-story complexes.',
    markets: ['Hotels', 'Villas', 'Developments'],
  },
  {
    icon: 'ri-ship-line',
    number: '04',
    title: 'International Trade & Logistics',
    subtitle: 'End-to-End Coordination',
    description:
      'Comprehensive international trade services including sourcing, quality inspection, documentation, shipping coordination, and last-mile delivery management.',
    markets: ['Sourcing', 'QC Inspection', 'Shipping'],
  },
];

export default function Services() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="services" className="py-32 bg-charcoal">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div
          ref={ref}
          className={`mb-16 transition-all duration-800 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="text-gold text-[10px] font-semibold tracking-[0.35em] uppercase mb-5 block">
            What We Do
          </span>
          <div className="flex items-end justify-between flex-wrap gap-6">
            <div>
              <h2 className="font-heading text-4xl md:text-5xl font-light text-white leading-tight">
                Our Core<br />
                <em className="not-italic text-gold">Services</em>
              </h2>
              <div className="section-divider mt-5" />
            </div>
            <p className="text-[#7A7A7A] text-sm max-w-md leading-relaxed tracking-wide">
              From single vehicle exports to full-scale procurement for international development projects.
            </p>
          </div>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-charcoal-border">
          {services.map((service, i) => (
            <div
              key={service.number}
              className={`bg-charcoal p-10 card-hover border border-transparent group transition-all duration-700 ${
                isVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              {/* Number + Icon Row */}
              <div className="flex items-start justify-between mb-8">
                <span className="font-heading text-6xl font-light text-charcoal-border leading-none select-none group-hover:text-gold/20 transition-colors duration-300">
                  {service.number}
                </span>
                <div className="w-12 h-12 flex items-center justify-center border border-charcoal-border group-hover:border-gold/50 transition-colors duration-300">
                  <i className={`${service.icon} text-gold text-xl`} />
                </div>
              </div>

              {/* Title */}
              <h3 className="font-heading text-2xl text-white font-light mb-1 group-hover:text-gold transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-[10px] text-gold tracking-[0.2em] uppercase mb-5">{service.subtitle}</p>

              {/* Description */}
              <p className="text-[#7A7A7A] text-sm leading-relaxed tracking-wide mb-7">
                {service.description}
              </p>

              {/* Tags */}
              <div className="flex flex-wrap gap-2">
                {service.markets.map((tag) => (
                  <span
                    key={tag}
                    className="text-[10px] text-charcoal-text border border-charcoal-border px-3 py-1 tracking-wider group-hover:border-gold/30 group-hover:text-gold/70 transition-all duration-300"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
